import { NavLink } from 'react-router-dom';
import { LuEllipsis } from 'react-icons/lu';
import { primaryRoutes } from '../../routes';
import { useTr } from '../../context/langContext';
import { webStrings } from '../../i18n/web-strings';

export const BOTTOM_NAV_HEIGHT = 62;

/** Mobile navigation: the four primary destinations plus "More" (the Flutter home tiles). */
export default function BottomNav({ moreOpen, onOpenMore }: { moreOpen: boolean; onOpenMore: () => void }) {
    const tr = useTr();
    return (
        <nav
            className="fixed inset-x-0 bottom-0 z-40 flex border-t border-line bg-surf2"
            style={{ height: BOTTOM_NAV_HEIGHT }}
        >
            {primaryRoutes.map(({ to, name, short, icon: Icon }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) =>
                        `flex flex-1 flex-col items-center justify-center gap-1 text-[10px] font-semibold ${
                            isActive && !moreOpen ? 'text-owner-ink' : 'text-ink3'
                        }`
                    }
                >
                    <Icon size={19} />
                    <span className="max-w-full truncate px-1">{(short ?? name)(tr)}</span>
                </NavLink>
            ))}
            <button
                onClick={onOpenMore}
                className={`flex flex-1 flex-col items-center justify-center gap-1 text-[10px] font-semibold ${
                    moreOpen ? 'text-owner-ink' : 'text-ink3'
                }`}
            >
                <LuEllipsis size={19} />
                <span>{tr(webStrings, 'more')}</span>
            </button>
        </nav>
    );
}
